import { getRequestBaseData } from "./baseRequest";

export default async function CommonHeader(pageType=null) {
    let headerParams = {};
    let bearerData = await getRequestBaseData(pageType);
    
    try {
        bearerData = JSON.stringify(bearerData);
        let encodedBearerData = btoa(unescape(encodeURIComponent(bearerData))); 
        headerParams.bearerData = encodedBearerData;
    } catch (error) {
        console.error("Error encoding bearerData:", error);
    }

    return headerParams;
}
